module.exports = __webpack_public_path__ + "img/rotate-right.4d8bfde2.svg";